/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

export const windowSize = {};

windowSize.util = (() => {
  function valueMatches(documentWidth, operation, breakpoint) {
    let match;
    switch (operation) {
      case '<':
        match = documentWidth < breakpoint;
        break;
      case '>':
        match = documentWidth > breakpoint;
        break;
      case '=':
        match = documentWidth === breakpoint;
        break;
      default:
        match = null;
    }
    return match;
  }
  return {
    valueMatches: valueMatches,
  };
})();
